import React from "react";
import { Icon } from "@iconify/react";

const ModalContainer = ({
  open,
  setOpen,
  children,
  title,
  subTitle,
  secondary,
  padding,
  footer,
  className,
  childClassname,
  header,
  onClickOutside,
}) => {
  return (
    <div
      className={`fixed z-[51] top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75 ${
        open ? "flex" : "hidden"
      } ${className}`}
      style={{
        transform: "translateZ(0)",
      }}
    >
      <div
        className="flex flex-1 h-full"
        onClick={() => onClickOutside?.()}
      ></div>
      <div
        className={`flex flex-col w-full h-full items-center ${
          childClassname || "max-w-[887px]"
        }`}
      >
        <div
          className="flex flex-1 flex-col w-full "
          onClick={() => onClickOutside?.()}
        ></div>
        <div
          className={`bg-white w-[90vw] lg:w-full rounded-b-lg shadow-md lg:max-h-[90vh] mx-4 overflow-scroll scroll-hide ${
            childClassname || "max-w-[887px]"
          }`}
        >
          {header || (
            <div
              className={`${
                secondary ? "bg-[#F0F6FF]" : "bg-primary1"
              } z-20 px-2.5 py-3 sm:px-6 sm:py-5 flex justify-between items-center top-0 sticky`}
            >
              <div className="flex-col">
                <h2
                  className={`font-bold ${
                    secondary ? "text-black" : "text-secondary"
                  } text-base sm:text-2xl`}
                >
                  {title}
                </h2>
                {subTitle && (
                  <span
                    className={`${
                      secondary ? "text-black" : "text-secondary"
                    } text-xs sm:text-sm`}
                  >
                    {subTitle}
                  </span>
                )}
              </div>
              <button onClick={() => setOpen(false)}>
                <Icon
                  icon="material-symbols:close"
                  className={`${
                    secondary ? "text-black" : "text-secondary"
                  } text-3xl`}
                />
              </button>
            </div>
          )}
          <div
            className={`${
              padding || "pt-6 px-4 pb-4 sm:p-16"
            } z-10 flex flex-col gap-2 relative`}
          >
            {children}
            {footer ? (
              <div className="bottom-6 sticky w-full bg-red">{footer}</div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div
          className="flex flex-1 flex-col w-full "
          onClick={() => onClickOutside?.()}
        ></div>
      </div>
      <div
        className="flex flex-1 h-full"
        onClick={() => onClickOutside?.()}
      ></div>
    </div>
  );
};

export default ModalContainer;
